import { Icon } from "./Icon";
import type { AppRoute } from "../lib/routes";
import "./AppNav.css";

export type { AppRoute } from "../lib/routes";

type AppNavProps = {
  activeRoute: AppRoute;
  cartCount: number;
  isAdmin: boolean;
  onNavigate: (route: AppRoute) => void;
};

const customerNavItems: Array<{
  icon: "catalog" | "cart" | "orders";
  label: string;
  route: "catalog" | "cart" | "orders";
}> = [
  { icon: "catalog", label: "Catalogue", route: "catalog" },
  { icon: "cart", label: "Cart", route: "cart" },
  { icon: "orders", label: "Orders", route: "orders" },
];

const adminNavItems: Array<{
  icon: "catalog" | "cart" | "orders";
  label: string;
  route: "catalog" | "cart" | "orders";
}> = [
  { icon: "catalog", label: "Catalogue", route: "catalog" },
  { icon: "orders", label: "Orders", route: "orders" },
  { icon: "cart", label: "Cart", route: "cart" },
];

export function AppNav({ activeRoute, cartCount, isAdmin, onNavigate }: AppNavProps) {
  const navItems = isAdmin ? adminNavItems : customerNavItems;
  const highlightedRoute =
    activeRoute === "category" || activeRoute === "product"
      ? "catalog"
      : activeRoute === "payment" || activeRoute === "order"
        ? "orders"
        : activeRoute;

  return (
    <nav className="app-nav" aria-label="Primary navigation">
      {navItems.map((item) => (
        <a
          aria-current={highlightedRoute === item.route ? "page" : undefined}
          className="app-nav__link"
          href={`/${item.route}`}
          key={item.route}
          onClick={(event) => {
            event.preventDefault();
            onNavigate(item.route);
          }}
        >
          <span className="app-nav__icon">
            <Icon name={item.icon} />
            {item.route === "cart" && !isAdmin && cartCount > 0 ? (
              <strong className="app-nav__badge">{cartCount}</strong>
            ) : null}
          </span>
          <span>{item.label}</span>
        </a>
      ))}
    </nav>
  );
}
